const ALLOWED_ORIGIN_SUFFIXES = ['kodland.org', 'kodland.id', 'core.local:8000'];

// Mirror TLDs the GUI may be served from: kodland.org is DNS-blocked in
// Indonesia, so the same build is also served on kodland.id and has to talk to
// the backend of whichever domain the page came from.
const MIRROR_TLDS = ['id'];

const mirrorTld = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const match = window.location.hostname.match(/\.kodland\.([a-z]+)$/);
    return match && MIRROR_TLDS.includes(match[1]) ? match[1] : null;
};

const configuredApi = process.env.SCRATCH_API || '';
const tld = mirrorTld();

export const scratchApi = tld ?
    configuredApi.replace(/kodland\.[a-z]+$/, `kodland.${tld}`) :
    configuredApi;

export const isAllowedOrigin = origin =>
    ALLOWED_ORIGIN_SUFFIXES.some(suffix => origin.endsWith(suffix));
